import React from 'react';
import { GridContainer, LeftSideBar, CenterContent, RightSideBar } from 'global/components/perform-grid';
import Filters from './filters';
import Table from './table';
import { useScreen } from 'global/styles';
// import { useClients } from 'global/hooks/useVendors';

export default (props) => {
  const { isMobile } = useScreen();
  // const vendors = useClients();

  return (
    <GridContainer>
      <LeftSideBar hidden={isMobile}>
        <Filters />
      </LeftSideBar>

      <CenterContent>
        {isMobile && <Filters />}
        <Table allowedPermissions={['manageUsers']} />
      </CenterContent>

      <RightSideBar />
    </GridContainer>
  );
};
